import React, { useState, useEffect } from "react";
import ToolkitProvider, { CSVExport, Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { API_ROUTE_CONTROLLER } from "../../../app/base/routes";
import { ApiServices } from "../../../app/base/service/apiService";
import { useSelector } from "react-redux";
import { Row, Col, Tabs, Tab, Modal, Table } from 'react-bootstrap';
import styles from "./scss/tableview.module.scss";
import ToastSuccess from "../../toastSuccess";
import { useNavigate } from "react-router-dom";
import paginationFactory from 'react-bootstrap-table2-paginator';
import leftarr from "../../../styles/images/leftpagination.svg";
import rightarr from "../../../styles/images/rightpagination.svg";
import EmptyData from '../../../styles/images/nodata.svg';

const UserSetting = () => {
  const navigate = useNavigate();
  const _login = useSelector((state: any) => state.login.login);
  const userDetails = useSelector((state: any) => state.user.editUserInfo);
  console.log("user", userDetails)
  const [selectedRows, setSelectedRows] = useState<any>([]);
  console.log("selectedRows", selectedRows)
  const [adduserdatas, Setadduserdatas] = useState<any>([]);
  console.log("adduserdatas", adduserdatas)
  const [msg, setMsg] = useState<any>("");


  const [columns2, setColumns2] = useState([
    // { dataField: 'name', text: 'User name', sort: true },
    // { dataField: 'ext_number', text: 'Ext', sort: true },
    { dataField: 'department', text: 'Department', sort: true },
    { dataField: 'memberscount', text: 'User count', sort: true },

  ]);

  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selectedRows,
    onSelect: (row: any, isSelect: any, rowIndex: any, e: any) => {
      // setSelectedRows(isSelect ? [...selectedRows, row] : selectedRows.filter(selectedRow => selectedRow.id !== row.id));
      if (isSelect) {
        setSelectedRows([...selectedRows, row.id]);
      } else {
        setSelectedRows(selectedRows.filter(x => x !== row.id));
      }

    },
    onSelectAll: (isSelect: any, rows: any, e: any) => {
      console.log("rows", rows)
      // setSelectedRows(isSelect ? rows : []);
      if (isSelect) {
        setSelectedRows(rows.map(r => r.id));
      } else {
        setSelectedRows([]);
      }
    }

  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: 'First',
    prePageText: <img src={leftarr} />,
    nextPageText: <img src={rightarr} />,
    lastPageText: 'Last',
    nextPageTitle: 'First page',
    prePageTitle: 'Pre page',
    firstPageTitle: 'Next page',
    lastPageTitle: 'Last page',
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [{
      text: '10', value: 10
    }, {
      text: '20', value: 20
    }, {
      text: 'All', value: adduserdatas.length
    }] // A numeric array is also available. the purpose of above example is custom the text
  };



  const { SearchBar, ClearSearchButton } = Search;

  const getUsersList = async () => {
    let _url = API_ROUTE_CONTROLLER.get_master_dept_list + "/" + _login.company_id;

    ApiServices.get(_url).then(async (value: any) => {
      console.log("vaaaluuueee", value.data.result);
      let newArr = [...value?.data?.result]
      if (value.data.statusCode === 0) {
        newArr.map((value, index) => {
          value.id = index + 1;
        })
        Setadduserdatas(newArr);
        getdepList(newArr);

      }
    })
  }

  const insertDeptDetails = async () => {
    let deptString: any = selectedRows.map((row) => {
      return adduserdatas.filter(user => user?.id == row);
    })
    let newString: any = deptString.flat().map((value) => value?.department).join(",")
    // console.log("deptString",deptString.flat().map((value)=>value?.department).join(","))

    let _url = API_ROUTE_CONTROLLER.insertUpdate_UserDeptContact;
    let _body = {
      p_companyId: _login.company_id,
      p_email: userDetails[0].email,
      p_dept: newString
    }
    console.log("_body", _body)
    ApiServices.post(_body, _url).then(async (value: any) => {
      console.log("res", value)
      if (value.data.result[0].errmsg == 'Inserted' || value.data.result[0].errmsg == 'Updated') {
        getUsersList();
      }
      setMsg("Updated Successfully");
      setTimeout(() => {
        setMsg("");
      }, 2000);

    });
  }

  const getdepList = async (adduser) => {

    let _url = API_ROUTE_CONTROLLER.get_User_Dept_Contact + "/" + parseInt(_login.company_id) + "/" + userDetails[0].email;
    ApiServices.get(_url).then(async (value: any) => {
      console.log("depList", value?.data?.result[0][0]?.dept.split(","))
      let newVal = value?.data?.result[0][0]?.dept.split(",");
      console.log("adduserdatas", adduser)
      let Arr: any = newVal.map((val) => {
        console.log("valll", val)
        return adduser.findIndex(user => user?.department == val) + 1;


      })
      setSelectedRows(Arr)
      console.log("Arr", Arr)



    }).catch(() => {

    });
  }

  useEffect(() => {
    getUsersList();

  }, [])

  const expandRow = {
		renderer: (row: any, index: any) => (
			<div id={index} className="expandtable">
				<ul>
					<li><span>User count</span>{row.memberscount}</li>
				</ul>
			</div>
		),
		showExpandColumn: true, expandColumnPosition: "center", expandHeaderColumnRenderer: ({ isAnyExpands }) => {
			if (isAnyExpands) {
				return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
			}
			return <b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>;
		},
		expandColumnRenderer: ({ expanded }) => {
			if (expanded) {
				return (
					<b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: "rotate(180deg)" }}><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
				);
			}
			return (
				<b><svg width="14" height="6" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#000000"></path></svg></b>
			);
		}
	};


  return (
    <>
    <div className="breadcrumbarea">
      <h4>User Settings</h4>
      <p></p>
    </div>
      <div className={styles.usersettingsmain}>
        <ToolkitProvider keyField="id" data={adduserdatas} columns={columns2} search={{ defaultSearch: '' }} exportCSV={{
              fileName: 'assigned-number.csv',
              ignoreHeader: false,
              noAutoBOM: false
            }}>
              {(props: any) => (
                <>
                    <Row className={`${styles.toplayers} ${styles.toplayersuser}`}>
                      <Col sm={6} className={styles.lefts}>
                        <div className="searchclear">
                          <SearchBar {...props.searchProps} />
                          <ClearSearchButton {...props.searchProps} className="clears" />
                        </div>
                      </Col>
                    </Row>
                      <div className={`${styles.usersettingtable} paginationscroll`}>
                          <div className="desktopmobile">
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(options)}
                              selectRow={selectRow}
                              noDataIndication={
                                <div className='emptyDataInTable'>
                                  <img src={EmptyData} alt="img"></img>
                                  <p>No data found</p>
                                </div>
                              } />
                          </div>
                          <div className="mobiletable checkboxtablemobile mobiletablesetur">
                            <BootstrapTable
                              {...props.baseProps}
                              pagination={paginationFactory(options)}
                              selectRow={selectRow}
                              expandRow={expandRow}
                              noDataIndication={
                                <div className='emptyDataInTable'>
                                  <img src={EmptyData} alt="img"></img>
                                  <p>No data found</p>
                                </div>
                              } />
                            </div>
                         
                      </div>
                </>
              )}
        </ToolkitProvider>
      </div>
      <div className={styles.bottomarea}>
        <div className={styles.bottomareainner}>
          <button className="cancelbtn" onClick={() => { navigate("/usermanagement") }} >Cancel</button>
          <button onClick={insertDeptDetails} >Save</button>
        </div>
      </div>


      {msg != "" && <ToastSuccess msg={msg}></ToastSuccess>}


    </>
  )

}
export default UserSetting;